module.exports = __webpack_public_path__ + "static/img/yaozhuoxing.a5faf1b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yaozhuoxing.jpg
// module id = QEbD
// module chunks = 1